module.exports = __webpack_public_path__ + "img/14.922c0aa8.svg";